<template>

    <header class="home-header">

        <home-header-hero v-if="Object.keys(homeHeaderParams).length > 0" :home-header-hero-params="homeHeaderParams"></home-header-hero>

        <!--<features
                :features-filter-params="featuresFilterParams"
                :features-force-loading="true"
                features-id="homeFeatures"
                :features-max-items="6"
                features-heading="Features"
        ></features>-->

    </header>

</template>

<script>

    // console.log('HomeHeader');

    import env from '../env';

    import cssMediaQueryHelper from '../services/cssMediaQueryHelper';
    import cssUnitHelper from '../services/cssUnitHelper';

    import Features from './Features.vue';
    import HomeHeaderHero from './HomeHeaderHero.vue';

    export default {
        created(){
            window.addEventListener('scroll', this.scrollHandler, { passive : true });
        },
        destroyed(){
            window.removeEventListener('scroll', this.scrollHandler);
        },
        mounted(){
            this.parallaxElement = this.$el.querySelector('.features');
            try{
              this.scrollHandler();
            }catch (e){console.log(e);}
        },
        components : {
            Features,
            HomeHeaderHero,
        },
        data(){
            return {
                featuresFilterParams : {
                    seriesKeywords : [env.PAGE_ID_GLOSSAR],
                },
                parallaxElement : null,
                parallaxMaxPx : cssUnitHelper.remToPx(24 - 3.5),
                parallaxFactor : 0.25,
            };
        },
        props : {
          'homeHeaderParams' : {
            default : {},
            type : Object,
          }
        },
        methods : {
            scrollHandler(){
                const parallaxMaxPx = this.parallaxMaxPx * cssMediaQueryHelper.watch.factor;
                const parallaxScrollPx = (window.scrollY || window.pageYOffset) * this.parallaxFactor;
                const parallaxTranslatePx = Math.min(parallaxMaxPx, parallaxScrollPx);
                if(this.parallaxElement != null){
                  this.parallaxElement.style.transform = 'translateY(-' + parallaxTranslatePx + 'px)';
                }
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    $carousel-height: 384px;
    .home-header {
        position: relative;
        height: 258px;
        margin-bottom: 24px;
        @media screen and (min-width: 768px) {
            margin-bottom: 60px;
            height: 480px;//$carousel-height * $factor-720;
        }
        /*@media screen and (min-width: 992px) {
            height: $carousel-height * $factor-960;
        }
        @media screen and (min-width: 1200px) {
            height: $carousel-height * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            height: $carousel-height * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            height: $carousel-height * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            height: $carousel-height * $factor-2400;
        }*/
        .features {
            background-color: transparentize($color-nochvielvor-pink, 0.1);
            transition: transform 400ms cubic-bezier(0.175, 0.885, 0.320, 1.275);
            will-change: transform;
        }
    }

    _:-ms-lang(x), .home-header .features {
        transition: none;
    }

</style>



// WEBPACK FOOTER //
// public/js/components/HomeHeader.vue